import { useSuspenseQuery } from '@tanstack/react-query'

import type { TUnidadesDeNegocioDisponiveisResponse } from '@/features/regionais/interfaces/unidade-de-negocio.types'
import { GetUnidadeDeNegocioService } from '@/features/regionais/services/get-unidade-de-negocio.service'
import { regionaisKeys } from '@/features/regionais/utils/queries'

export const useSuspenseRegionais = () => {
  return useSuspenseQuery<TUnidadesDeNegocioDisponiveisResponse>({
    queryKey: regionaisKeys.listas(),
    queryFn: () => new GetUnidadeDeNegocioService().execute().then((response) => response.data),
    staleTime: 60 * 60 * 1000,
  })
}
